import React from "react";
import Form from "react-bootstrap/Form";
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';

export default function CleanerSchedule(props) {
  const { label, tooltext } = props;
  return (
    <>

      <Form.Label>{label}</Form.Label>
      <Box sx={{ width: 500 }}>
        <Grid container justifyContent="start">

          <Grid item container alignItems="flex-start" direction="column">

            <Grid item alignItems="flex-center" className='d-flex'>

              <Tooltip title={tooltext} placement="top" arrow>
                <Button className='justify-content-space-between'>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" fill="rgba(0,0,0,1)"><path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z"></path></svg>
                </Button>

              </Tooltip>
            </Grid>
          </Grid>
        </Grid>

      </Box>
    </>
  );
}